import { render } from "./MainCongTy.vue?vue&type=template&id=ae0659aa"
import script from "./MainCongTy.vue?vue&type=script&lang=js"
export * from "./MainCongTy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__